export default {
  install (Vue, {lang, txt}) {
    Vue.prototype.$txt = label => {
      if (!txt[lang]) return
      return txt[lang][label] || label
    }
  }
}